export default __webpack_public_path__ + "static/media/misc-fireplaceA-1440w.63032bc0.avif";